var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.TENANTID==59)?_c('img',{staticClass:"flowPathPicture",attrs:{"src":require("../../assets/images/home/59saas.png"),"alt":""}}):_c('img',{staticClass:"flowPathPicture",attrs:{"src":require("../../assets/images/home/flowPathPicture.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }